module.exports = __webpack_public_path__ + "static/media/test8_1.489328e0.png";